import { api } from "./helpers/api";

const cleanDocument = (document) =>
  JSON.parse(
    JSON.stringify(document, (key, value) =>
      key.startsWith("_") ? undefined : value
    )
  );
const upload = async (contentId, file, name) => {
  const data = new FormData();
  data.append("arquivo", file);
  data.append("nome", name || file.name);
  data.append("tipo", "IMAGEM");
  return (await api.post(`/app/conteudos/${contentId}/arquivos`, data)).data
    .arquivo;
};

export default {
  methods: {
    queueContentCover(event) {
      this._pendingCover = event.target.files?.[0] || null;
    },
    queueContentImage(block, event) {
      block._pendingFile = event.target.files?.[0] || null;
    },
    async saveContentWithUploads() {
      if (!this.document?.blocks?.length)
        return this.$swal.fire({
          icon: "warning",
          title: "Adicione conteúdo à aula.",
        });
      this.saving = true;
      try {
        let id = this.form.id;
        const initial = {
          ...this.form,
          conteudo: cleanDocument(this.document),
        };
        if (!id)
          id = (await api.post("/app/conteudos", initial)).data.conteudo.id;
        if (this._pendingCover)
          this.form.capa = (
            await upload(id, this._pendingCover, "Capa do conteúdo")
          ).arquivo;
        for (const block of this.document.blocks) {
          if (block._pendingFile)
            block.data.url = (
              await upload(
                id,
                block._pendingFile,
                block.data.caption || block._pendingFile.name
              )
            ).arquivo;
        }
        if (this.attachment) {
          const data = new FormData();
          data.append("arquivo", this.attachment);
          data.append("nome", this.attachment.name);
          await api.post(`/app/conteudos/${id}/arquivos`, data);
        }
        await api.put(`/app/conteudos/${id}`, {
          ...this.form,
          conteudo: cleanDocument(this.document),
        });
        document
          .querySelector('#contentModal [data-bs-dismiss="modal"]')
          ?.click();
        await this.load();
        await this.$swal.fire({ icon: "success", title: "Conteúdo guardado." });
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Não foi possível guardar",
          text: error.response?.data?.message || error.message,
        });
      } finally {
        this.saving = false;
        this._pendingCover = null;
      }
    },
  },
};
